export default "__VITE_PUBLIC_ASSET__32f607da__"